<template>
    <v-dialog v-model="isOpen" :max-width="dialogMaxWidth">
        <div class="dialogClose">
            <div v-on:mousedown.prevent="isOpen=false" v-on:touchstart.prevent="isOpen=false"><img
                    src="/images/common/close.png" :style="dialogCloseBtnStyle" /></div>
        </div>
        <div class="dialogBase dialogGet" @click="isOpen=false" :style="getBgStyle">
            <div class="stars">
                <span class="s"></span>
                <span class="s"></span>
                <span class="m"></span>
                <span class="m"></span>
                <span class="l"></span>
                <span class="l"></span>
                <span class="l"></span>
                <span class="l"></span>
            </div>
        </div>
    </v-dialog>
</template>
<style scoped>
.dialogGet {
    position: relative;
    background-color: white;
    background-position: top;
    background-repeat: no-repeat;
    background-size: 100%;
    animation: back-anim 0.5s 0s 1;
}

@keyframes back-anim {
    0% {}

    30% {
        transform: scale(-1, 1);
    }

    100% {}
}

.dialogGet::before {
    content: '';
    display: block;
    padding-top: 145%;
}

.stars {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

.stars span {
    position: relative;
    /* opacity: 0; */
}

.stars span:before {
    content: "";
    position: absolute;
    background-position: top;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url(@/static/images/star.png);

}

.stars span.s:before {
    width: 4.5vw;
    height: 4.5vw;
}

.stars span.m:before {
    width: 7.5vw;
    height: 7.5vw;
}

.stars span.l:before {
    width: 9vw;
    height: 9vw;
}

.stars span:nth-child(1) {
    left: 66%;
    top: 5.5%;
    animation: star-anim 9s -3s infinite;
}

.stars span:nth-child(2) {
    left: 13%;
    top: 79%;
    animation: star-anim 8s 0s infinite;
}

.stars span:nth-child(3) {
    left: 72%;
    top: 36%;
    animation: star-anim 14s -7s infinite;
}

.stars span:nth-child(4) {
    left: 14%;
    top: 31%;
    animation: star-anim 7s 1.3s infinite;
}

.stars span:nth-child(5) {
    left: 69%;
    top: 7%;
    animation: star-anim 12s -8.7s infinite;
}

.stars span:nth-child(6) {
    left: 84%;
    top: 48%;
    animation: star-anim 6s -3s infinite;
}

.stars span:nth-child(7) {
    left: 70%;
    top: 80%;
    animation: star-anim 7s 1.1s infinite;
}

.stars span:nth-child(8) {
    left: 17%;
    top: 85%;
    animation: star-anim 8s -2.8s infinite;
}

/*アニメーションキーフレーム*/
@keyframes star-anim {
    0% {
        opacity: 0;
    }

    5% {
        opacity: 1;
    }

    10% {
        opacity: 0;
    }

    55% {
        opacity: 0;
    }

    60% {
        opacity: 1;
    }

    95% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
<script>

import '@/assets/style/window.css';

export default {
    data: () => ({
        isOpen: true,
        getBgStyle: "",
        dialogMaxWidth: 400,
        dialogCloseBtnStyle: "",
    }),
    props: {
        data: {
            type: Object,
            default: {},
            required: true
        }
    },
    created: function () {
        if (this.dialogMaxWidth * 1.5 > window.innerHeight) {
            this.dialogMaxWidth = window.innerHeight / 1.6;
            this.dialogCloseBtnStyle = "width:min(8vw, 48px) !important";
        }

        this.updateData();

    },
    destroyed: function () {
    },
    methods: {
        updateData() {
            if (this.data) {
                this.getBgStyle = "background-image:url(/images/puzzle/getpiece_" + this.data.frame + "_" + (Number(this.data.num) + 1) + ".png)";
            }
        }
    },
    computed: {

    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close', this.data);
            }
        },
        data(newVal) {
            // console.log("getWinChange", newVal);
            this.updateData();
        }
    }
}
</script>